export const SIZES = {
  XSMALL: "XSMALL",
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE"
};
export const ICON_SIZES = {
  [SIZES.XSMALL]: "xs",
  [SIZES.SMALL]: "s",
  [SIZES.MEDIUM]: "m",
  [SIZES.LARGE]: "l"
};
